import { Box, Typography } from '@mui/material';

import { TipoPagamento } from '../../../../models/TipoPagamento';
import { isPagamentoYuno } from '../../../../shared/functions/tipoPagamento';
import { PagamentoAdyen } from '../PagamentoAdyen/PagamentoAdyen';
import { PagamentoYuno } from '../PagamentoYuno/PagamentoYuno';

interface Props {
  pagamentoId?: string;
  pagamentoValor?: number;
  tipoPagamento:
    | TipoPagamento.CartaoCredito
    | TipoPagamento.CartaoDebito
    | TipoPagamento.YunoCredito
    | TipoPagamento.YunoDebito;
  onPaymentFailed: (reason?: string) => void;
  onPaymentCompleted: () => void;
}

const PagamentoPorCartao = ({
  pagamentoId = '',
  pagamentoValor,
  tipoPagamento,
  onPaymentFailed,
  onPaymentCompleted
}: Props) => {
  const usarYuno = isPagamentoYuno(tipoPagamento);

  return (
    <Box>
      <Typography variant="h6" color="secondary.main">
        {tipoPagamento === TipoPagamento.CartaoCredito ||
        tipoPagamento === TipoPagamento.YunoCredito
          ? 'Cartão de crédito'
          : 'Cartão de débito'}
      </Typography>
      {usarYuno ? (
        <PagamentoYuno
          type="card"
          pagamentoId={pagamentoId}
          pagamentoValor={pagamentoValor}
          tipoCartao={tipoPagamento as TipoPagamento.YunoCredito | TipoPagamento.YunoDebito}
          onPaymentFailed={onPaymentFailed}
          onPaymentCompleted={onPaymentCompleted}
        />
      ) : (
        <PagamentoAdyen
          type="card"
          pagamentoId={pagamentoId}
          tipoCartao={tipoPagamento as TipoPagamento.CartaoCredito | TipoPagamento.CartaoDebito}
          onPaymentFailed={onPaymentFailed}
          onPaymentCompleted={onPaymentCompleted}
        />
      )}
    </Box>
  );
};

export default PagamentoPorCartao;
